import { render, staticRenderFns } from "./TextResponseAiFeedback.vue?vue&type=template&id=0f9d9a5f&scoped=true"
import script from "./TextResponseAiFeedback.vue?vue&type=script&lang=js"
export * from "./TextResponseAiFeedback.vue?vue&type=script&lang=js"
import style0 from "./TextResponseAiFeedback.vue?vue&type=style&index=0&id=0f9d9a5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d9a5f",
  null
  
)

export default component.exports